var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBluetoothX = function SvgIconBluetoothX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.85 2.2a1 1 0 0 0-1.6.8v7l-4.4-3.3a1 1 0 1 0-1.2 1.6L9.583 12 4.65 15.7a1 1 0 0 0 1.2 1.6l4.4-3.3v7a1 1 0 0 0 1.6.8l6-4.5a1 1 0 0 0 0-1.6L12.917 12l1.22-.916a1 1 0 0 0-1.2-1.6L12.25 10V5l.688.516a1 1 0 0 0 1.2-1.6zm3.733 14.3L12.25 19v-5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.457 5.957a1 1 0 0 0-1.414-1.414L19.5 6.086l-1.543-1.543a1 1 0 1 0-1.414 1.414L18.086 7.5l-1.543 1.543a1 1 0 1 0 1.414 1.414L19.5 8.914l1.543 1.543a1 1 0 0 0 1.414-1.414L20.914 7.5z"
  }))));
};
export default SvgIconBluetoothX;